import  { lazy } from 'react';
const Dashboard = lazy (()=> import ('../components/dashboard/dashboard1/dashboard'));
const Dashboard2 = lazy (()=> import ('../components/dashboard/dashboard2/dashboard2'));
const Dashboard3 = lazy (()=> import ('../components/dashboard/dashboard3/dashboard3'));
const Cards = lazy (()=> import ('../components/app/cards/cards'));
const Rangeslider = lazy (()=> import ('../components/app/range-slider/rangeslider'));
const Calendar = lazy (()=> import ('../components/app/calendar/calendar'));
const Contacts = lazy (()=> import ('../components/app/contacts/contacts'));
const Imagecompare = lazy (()=> import ('../components/app/image-compare/imagecompare'));
const Notification = lazy (()=> import ('../components/app/notification/notification'));
const Widgetnotification = lazy (()=> import ('../components/app/widget-notification/widget-notification'));
const Treeview = lazy (()=> import ('../components/app/treeview/treeview'));
const Filemanager = lazy (()=> import ('../components/app/file-manager/filemanager'));
const Filemanager1 = lazy (()=> import ('../components/app/file-manager1/filemanager1'));
const Filedetails = lazy (()=> import ('../components/app/file-details/filedetails'));
const Alerts = lazy (()=> import ('../components/elements/alerts/alerts'));
const Avatar = lazy (()=> import ('../components/elements/avatar/avatar'));
const Breadcrumbs = lazy (()=> import ('../components/elements/breadcrumbs/breadcrumbs'));
const Buttons = lazy (()=> import ('../components/elements/buttons/buttons'));
const Badges = lazy (()=> import ('../components/elements/badge/badge'));
const Dropdowns = lazy (()=> import ('../components/elements/dropdown/dropdown'));
const Thumbnails = lazy (()=> import ('../components/elements/thumbnails/thumbnails'));
const ListGroups = lazy (()=> import ('../components/elements/listgroup/listgroup'));
const Navigation = lazy (()=> import ('../components/elements/navigation/navigation'));
const Images = lazy (()=> import ('../components/elements/images/images'));
const Paginations = lazy (()=> import ('../components/elements/pagination/pagination'));
const Popovers = lazy (()=> import ('../components/elements/popover/popover'));
const Progressbar = lazy (()=> import ('../components/elements/progress/progress'));
const Spinners = lazy (()=> import ('../components/elements/spinners/spinners'));
const Mediaobject = lazy (()=> import ('../components/elements/mediaobject/mediaobject'));
const Typography = lazy (()=> import ('../components/elements/typography/typography'));
const Tooltips = lazy (()=> import ('../components/elements/tooltip/tooltip'));
const Toasts = lazy (()=> import ('../components/elements/toast/toast'));
const Tags = lazy (()=> import ('../components/elements/tags/tags'));
const Tabss = lazy (()=> import ('../components/elements/tabs/tabs'));
const Accordions = lazy (()=> import ('../components/advancedui/accordion/accordion'));
const Carousels = lazy (()=> import ('../components/advancedui/carousel/carousel'));
const Collapse = lazy (()=> import ('../components/advancedui/collapse/collapse'));
const Modals = lazy (()=> import ('../components/advancedui/modals/modals'));
const Timeline = lazy (()=> import ('../components/advancedui/timeline/timeline'));
const Sweetalert = lazy (()=> import ('../components/advancedui/sweetalert/sweetalert'));
const Ratings = lazy (()=> import ('../components/advancedui/ratings/ratings'));
const Counters = lazy (()=> import ('../components/advancedui/counters/counters'));
const Search = lazy (()=> import ('../components/advancedui/search/search'));
const Userlist = lazy (()=> import ('../components/advancedui/userlist/userlist'));
const Blog = lazy (()=> import ('../components/advancedui/blog/blog'));
const Blogdetails = lazy (()=> import ('../components/advancedui/blog-details/blogdetails'));
const Editpost = lazy (()=> import ('../components/advancedui/edit-post/editpost'));
const Attachments = lazy (()=> import ('../components/advancedui/fileattachments/fileattachments'));
const Shop = lazy (()=> import ('../components/pages/ecommerce/shop/shop'));
const ProductDetails = lazy (()=> import ('../components/pages/ecommerce/productdetails/productdetails'));
const Cart = lazy (()=> import ('../components/pages/ecommerce/cart/cart'));
const Checkout = lazy (()=> import ('../components/pages/ecommerce/check-out/check-out'));
const Wishlist = lazy (()=> import ('../components/pages/ecommerce/wishlist/wishlist'));
const Profile = lazy (()=> import ('../components/pages/profile/profile'));
const Notificationslist = lazy (()=> import ('../components/pages/notifications-list/notifications-list'));
const Aboutus = lazy (()=> import ('../components/pages/aboutus/aboutus'));
const Settings = lazy (()=> import ('../components/pages/settings/settings'));
const Mail = lazy (()=> import ('../components/pages/mail/mail/mail'));
const MailCompose = lazy (()=> import ('../components/pages/mail/mailcompose/mailcompose'));
const Readmail = lazy (()=> import ('../components/pages/mail/read-mail/read-mail'));
const Mailsettings = lazy (()=> import ('../components/pages/mail/mailsettings/mailsettings'));
const Chat = lazy (()=> import ('../components/pages/mail/chat/chat'));
const Invoice = lazy (()=> import ('../components/pages/invoice/invoice'));
const Pricing = lazy (()=> import ('../components/pages/pricing/pricing'));
const Gallery = lazy (()=> import ('../components/pages/gallery/gallery'));
const Todotask = lazy (()=> import ('../components/pages/todotask/todotask'));
const Faqs = lazy (()=> import ('../components/pages/faqs/faqs'));
const EmptyPage = lazy (()=> import ('../components/pages/emptypage/emptypage'));
const Background = lazy (()=> import ('../components/utilities/background/background'));
const Border = lazy (()=> import ('../components/utilities/border/border'));
const Display = lazy (()=> import ('../components/utilities/display/display'));
const Flex = lazy (()=> import ('../components/utilities/flex/flex'));
const Height = lazy (()=> import ('../components/utilities/height/height'));
const Margin = lazy (()=> import ('../components/utilities/margin/margin'));
const Padding = lazy (()=> import ('../components/utilities/padding/padding'));
const Position = lazy (()=> import ('../components/utilities/position/position'));
const Width = lazy (()=> import ('../components/utilities/width/width'));
const Extras = lazy (()=> import ('../components/utilities/extras/extras'));
const FontAwesome = lazy (()=> import ('../components/icons/fontawesome/fontawesome'));
const MaterialDesignIcons = lazy (()=> import ('../components/icons/materialdesignicons/materialdesignicons'));
const SimpleLineIcons = lazy (()=> import ('../components/icons/simplelineicons/simplelineicons'));
const FeatherIcons = lazy (()=> import ('../components/icons/feathericons/feathericons'));
const IonicIcons = lazy (()=> import ('../components/icons/ionicicons/ionicicons'));
const FlagIcons = lazy (()=> import ('../components/icons/flagicons/flagicons'));
const Pe7Icons = lazy (()=> import ('../components/icons/pe7icons/pe7icons'));
const ThemifyIcons = lazy (()=> import ('../components/icons/themifyicons/themifyicons'));
const TypiconsIcons = lazy (()=> import ('../components/icons/typiconsicons/typiconsicons'));
const WeatherIcons = lazy (()=> import ('../components/icons/weathericons/weathericons'));
const MaterialIcons = lazy (()=> import ('../components/icons/materialicons/materialicons'));
const BootstrapIcons = lazy (()=> import ('../components/icons/bootstrapicons/bootstrapicons'));
const ChartJS = lazy (()=> import ('../components/charts/chartjs/chartjs'));
const Echart = lazy (()=> import ('../components/charts/echart/echart'));
const Apexcharts = lazy (()=> import ('../components/charts/apexcharts/apexcharts'));
const FormElements = lazy (()=> import ('../components/forms/formelements/formelements'));
const AdvancedForms = lazy (()=> import ('../components/forms/advancedforms/advancedforms'));
const FormLayouts = lazy (()=> import ('../components/forms/formlayouts/formlayouts'));
const FormValidation = lazy (()=> import ('../components/forms/formvalidation/formvalidation'));
const FormWizard = lazy (()=> import ('../components/forms/formwizard/formwizard'));
const FormEditor = lazy (()=> import ('../components/forms/formeditor/formeditor'));
const Formelementsizes = lazy (()=> import ('../components/forms/form-element-sizes/form-element-sizes'));
const FormInputSpinners = lazy (()=> import ('../components/forms/forminputspinners/forminputspinners'));
const DefaultTables = lazy (()=> import ('../components/tables/defaulttables/defaulttables'));
const DataTables = lazy (()=> import ('../components/tables/datatables/datatables'));
const Widgets = lazy (()=> import ('../components/widgets/widgets'));
const LeafletMaps = lazy (()=> import ('../components/maps/leafletmaps/leafletmaps'));
const Simplemaps = lazy (()=> import ('../components/maps/simplemaps/simplemaps'));
const Error501 = lazy (()=> import ('../components/pages/authentication/501error/501error'));

export const Routingdata = [
//Dashboard
  { path:`${import.meta.env.BASE_URL}dashboard/dashboard1`, element: <Dashboard /> },
  { path:`${import.meta.env.BASE_URL}dashboard/dashboard2`, element: <Dashboard2 />},
  { path:`${import.meta.env.BASE_URL}dashboard/dashboard3`, element: <Dashboard3 />},

  { path:`${import.meta.env.BASE_URL}app/cards`, element: <Cards />},
  { path:`${import.meta.env.BASE_URL}app/rangeslider`, element: <Rangeslider />},
  { path:`${import.meta.env.BASE_URL}app/calendar`, element: <Calendar /> },
  { path:`${import.meta.env.BASE_URL}app/contacts`, element: <Contacts /> },
  { path:`${import.meta.env.BASE_URL}app/imagecompare`, element: <Imagecompare /> },
  { path:`${import.meta.env.BASE_URL}app/notification`, element: <Notification /> },
  { path:`${import.meta.env.BASE_URL}app/widgetnotification`, element: <Widgetnotification /> },
  { path:`${import.meta.env.BASE_URL}app/treeview`, element: <Treeview /> },
  { path:`${import.meta.env.BASE_URL}app/filemanager`, element: <Filemanager /> },
  { path:`${import.meta.env.BASE_URL}app/filemanager1`, element: <Filemanager1 /> },
  { path:`${import.meta.env.BASE_URL}app/filedetails`, element: <Filedetails /> },

  { path:`${import.meta.env.BASE_URL}elements/alerts`, element: <Alerts /> },
  { path:`${import.meta.env.BASE_URL}elements/avatar`, element: <Avatar /> },
  { path:`${import.meta.env.BASE_URL}elements/breadcrumbs`, element: <Breadcrumbs /> },
  { path:`${import.meta.env.BASE_URL}elements/buttons`, element: <Buttons /> },
  { path:`${import.meta.env.BASE_URL}elements/badge`, element: <Badges /> },
  { path:`${import.meta.env.BASE_URL}elements/dropdown`, element: <Dropdowns /> },
  { path:`${import.meta.env.BASE_URL}elements/thumbnails`, element: <Thumbnails /> },
  { path:`${import.meta.env.BASE_URL}elements/listGroup`, element: <ListGroups /> },
  { path:`${import.meta.env.BASE_URL}elements/navigation`, element: <Navigation /> },
  { path:`${import.meta.env.BASE_URL}elements/images`, element: <Images /> },
  { path:`${import.meta.env.BASE_URL}elements/pagination`, element: <Paginations /> },
  { path:`${import.meta.env.BASE_URL}elements/popover`, element: <Popovers /> },
  { path:`${import.meta.env.BASE_URL}elements/progress`, element: <Progressbar /> },
  { path:`${import.meta.env.BASE_URL}elements/spinners`, element: <Spinners /> },
  { path:`${import.meta.env.BASE_URL}elements/mediaobject`, element: <Mediaobject /> },
  { path:`${import.meta.env.BASE_URL}elements/typography`, element: <Typography /> },
  { path:`${import.meta.env.BASE_URL}elements/tooltip`, element: <Tooltips /> },
  { path:`${import.meta.env.BASE_URL}elements/toast`, element: <Toasts /> },
  { path:`${import.meta.env.BASE_URL}elements/tags`, element: <Tags /> },
  { path:`${import.meta.env.BASE_URL}elements/tabs`, element: <Tabss /> },

  { path:`${import.meta.env.BASE_URL}advancedui/accordion`, element: <Accordions /> },
  { path:`${import.meta.env.BASE_URL}advancedui/carousel`, element: <Carousels /> },
  { path:`${import.meta.env.BASE_URL}advancedui/collapse`, element: <Collapse /> },
  { path:`${import.meta.env.BASE_URL}advancedui/modals`, element: <Modals /> },
  { path:`${import.meta.env.BASE_URL}advancedui/timeline`, element: <Timeline /> },
  { path:`${import.meta.env.BASE_URL}advancedui/sweetalert`, element: <Sweetalert /> },
  { path:`${import.meta.env.BASE_URL}advancedui/ratings`, element: <Ratings /> },
  { path:`${import.meta.env.BASE_URL}advancedui/counters`, element: <Counters /> },
  { path:`${import.meta.env.BASE_URL}advancedui/search`, element: <Search /> },
  { path:`${import.meta.env.BASE_URL}advancedui/userlist`, element: <Userlist /> },
  { path:`${import.meta.env.BASE_URL}advancedui/blog`, element: <Blog /> },
  { path:`${import.meta.env.BASE_URL}advancedui/blogdetails`, element: <Blogdetails /> },
  { path:`${import.meta.env.BASE_URL}advancedui/editPost`, element: <Editpost /> },
  { path:`${import.meta.env.BASE_URL}advancedui/fileattachments`, element: <Attachments /> },

  { path:`${import.meta.env.BASE_URL}pages/ecommerce/shop`, element: <Shop /> },
  { path:`${import.meta.env.BASE_URL}pages/ecommerce/productdetails`, element: <ProductDetails /> },
  { path:`${import.meta.env.BASE_URL}pages/ecommerce/cart`, element: <Cart /> },
  { path:`${import.meta.env.BASE_URL}pages/ecommerce/checkout`, element:<Checkout/> },
  { path:`${import.meta.env.BASE_URL}pages/ecommerce/wishlist`, element: <Wishlist /> },

  { path:`${import.meta.env.BASE_URL}pages/profile`, element: <Profile /> },
  { path:`${import.meta.env.BASE_URL}pages/notificationslist`, element: <Notificationslist /> },
  { path:`${import.meta.env.BASE_URL}pages/aboutus`, element: <Aboutus /> },
  { path:`${import.meta.env.BASE_URL}pages/settings`, element: <Settings /> },

  { path:`${import.meta.env.BASE_URL}pages/mail/mail`, element: <Mail /> },
  { path:`${import.meta.env.BASE_URL}pages/mail/mailcompose`, element: <MailCompose /> },
  { path:`${import.meta.env.BASE_URL}pages/mail/readmail`, element: <Readmail /> },
  { path:`${import.meta.env.BASE_URL}pages/mail/mailsettings`, element: <Mailsettings /> },
  { path:`${import.meta.env.BASE_URL}pages/mail/chat`, element: <Chat /> },

  { path:`${import.meta.env.BASE_URL}pages/invoice`, element: <Invoice /> },
  { path:`${import.meta.env.BASE_URL}pages/pricing`, element: <Pricing /> },
  { path:`${import.meta.env.BASE_URL}pages/gallery`, element: <Gallery /> },
  { path:`${import.meta.env.BASE_URL}pages/todotask`, element: <Todotask /> },
  { path:`${import.meta.env.BASE_URL}pages/faqs`, element: <Faqs /> },
  { path:`${import.meta.env.BASE_URL}pages/emptypage`, element: <EmptyPage /> },

  { path:`${import.meta.env.BASE_URL}utilities/background`, element: <Background /> },
  { path:`${import.meta.env.BASE_URL}utilities/border`, element: <Border /> },
  { path:`${import.meta.env.BASE_URL}utilities/display`, element: <Display /> },
  { path:`${import.meta.env.BASE_URL}utilities/flex`, element: <Flex /> },
  { path:`${import.meta.env.BASE_URL}utilities/height`, element: <Height /> },
  { path:`${import.meta.env.BASE_URL}utilities/margin`, element: <Margin /> },
  { path:`${import.meta.env.BASE_URL}utilities/padding`, element: <Padding /> },
  { path:`${import.meta.env.BASE_URL}utilities/position`, element: <Position /> },
  { path:`${import.meta.env.BASE_URL}utilities/width`, element: <Width /> },
  { path:`${import.meta.env.BASE_URL}utilities/extras`, element: <Extras /> },

  { path:`${import.meta.env.BASE_URL}icons/fontawesome`, element: <FontAwesome /> },
  { path:`${import.meta.env.BASE_URL}icons/materialdesignicons`, element: <MaterialDesignIcons /> },
  { path:`${import.meta.env.BASE_URL}icons/simplelineicons`, element: <SimpleLineIcons /> },
  { path:`${import.meta.env.BASE_URL}icons/feathericons`, element: <FeatherIcons /> },
  { path:`${import.meta.env.BASE_URL}icons/ionicicons`, element: <IonicIcons /> },
  { path:`${import.meta.env.BASE_URL}icons/flagicons`, element: <FlagIcons /> },
  { path:`${import.meta.env.BASE_URL}icons/pe7icons`, element: <Pe7Icons /> },
  { path:`${import.meta.env.BASE_URL}icons/themifyicons`, element: <ThemifyIcons /> },
  { path:`${import.meta.env.BASE_URL}icons/typiconsicons`, element: <TypiconsIcons /> },
  { path:`${import.meta.env.BASE_URL}icons/weathericons`, element: <WeatherIcons /> },
  { path:`${import.meta.env.BASE_URL}icons/materialicons`, element: <MaterialIcons /> },
  { path:`${import.meta.env.BASE_URL}icons/bootstrapicons`, element: <BootstrapIcons /> },

  { path:`${import.meta.env.BASE_URL}charts/chartjs`, element: <ChartJS /> },
  { path:`${import.meta.env.BASE_URL}charts/echart`, element: <Echart /> },
  { path:`${import.meta.env.BASE_URL}charts/apexcharts`, element: <Apexcharts /> },

  { path:`${import.meta.env.BASE_URL}forms/formelements`, element: <FormElements /> },
  { path:`${import.meta.env.BASE_URL}forms/advancedforms`, element: <AdvancedForms /> },
  { path:`${import.meta.env.BASE_URL}forms/formlayouts`, element: <FormLayouts /> },
  { path:`${import.meta.env.BASE_URL}forms/formvalidation`, element: <FormValidation /> },
  { path:`${import.meta.env.BASE_URL}forms/formwizard`, element: <FormWizard /> },
  { path:`${import.meta.env.BASE_URL}forms/formeditor`, element: <FormEditor /> },
  { path:`${import.meta.env.BASE_URL}forms/formelementsizes`, element: <Formelementsizes /> },
  { path:`${import.meta.env.BASE_URL}forms/forminputspinners`, element: <FormInputSpinners /> },

  { path:`${import.meta.env.BASE_URL}tables/defaulttables`, element: <DefaultTables /> },
  { path:`${import.meta.env.BASE_URL}tables/datatables`, element: <DataTables /> },

  { path:`${import.meta.env.BASE_URL}widgets`, element: <Widgets /> },

  { path:`${import.meta.env.BASE_URL}maps/leafletmaps`, element: <LeafletMaps /> },
  { path:`${import.meta.env.BASE_URL}maps/simplemaps`, element: <Simplemaps /> },
 { path:`${import.meta.env.BASE_URL}pages/authentication/501error`, element:<Error501 />}
];

export const Sidebarcomponents=[

  { path:`${import.meta.env.BASE_URL}dashboard/dashboard1`, title:'Dashboard-1' },
  { path:`${import.meta.env.BASE_URL}dashboard/dashboard2`, title:'Dashboard-2' },
  { path:`${import.meta.env.BASE_URL}dashboard/dashboard3`, title:'Dashboard-3' },

  { path:`${import.meta.env.BASE_URL}app/cards`, title:'Cards' },
  { path:`${import.meta.env.BASE_URL}app/rangeslider`, title:'Range-slider' },
  { path:`${import.meta.env.BASE_URL}app/calendar`, title:'Calendar' },
  { path:`${import.meta.env.BASE_URL}app/contacts`, title:'Contacts' },
  { path:`${import.meta.env.BASE_URL}app/imagecompare`, title:'Image-compare' },
  { path:`${import.meta.env.BASE_URL}app/notification`, title:'Notification' },
  { path:`${import.meta.env.BASE_URL}app/widgetnotification`, title:'Widget-notification' },
  { path:`${import.meta.env.BASE_URL}app/treeview`, title:'Treeview' },
  { path:`${import.meta.env.BASE_URL}app/filemanager`, title:'File-manager' },
  { path:`${import.meta.env.BASE_URL}app/filemanager1`, title:'File-manager1' },
  { path:`${import.meta.env.BASE_URL}app/filedetails`, title:'File-details' },

  { path:`${import.meta.env.BASE_URL}elements/alerts`,title: "Alerts" },
  { path:`${import.meta.env.BASE_URL}elements/avatar`, title: "Avatar" },

  {  path:`${import.meta.env.BASE_URL}elements/breadcrumbs`, title: "Breadcrumbs"},
  {  path:`${import.meta.env.BASE_URL}elements/buttons`, title: "Buttons"},
  {  path:`${import.meta.env.BASE_URL}elements/badge`, title: "Badges"},
  {  path:`${import.meta.env.BASE_URL}elements/dropdown`, title: "Dropdown"},
  {  path:`${import.meta.env.BASE_URL}elements/thumbnails`, title: "Thumbnails"},
  {  path:`${import.meta.env.BASE_URL}elements/listgroup`, title: "List Group"},
  {  path:`${import.meta.env.BASE_URL}elements/navigation`, title: "Navigation"},
  {  path:`${import.meta.env.BASE_URL}elements/images`, title: "Images"},
  {  path:`${import.meta.env.BASE_URL}elements/pagination`, title: "Pagination"},
  {  path:`${import.meta.env.BASE_URL}elements/popover`, title: "Popover"},
  {  path:`${import.meta.env.BASE_URL}elements/progress`, title: "Progress"},
  {  path:`${import.meta.env.BASE_URL}elements/spinners`, title: "Spinners"},
  {  path:`${import.meta.env.BASE_URL}elements/mediaObject`, title: "Media Object"},
  {  path:`${import.meta.env.BASE_URL}elements/typography`, title: "Typography"},
  {  path:`${import.meta.env.BASE_URL}elements/tooltip`, title: "Tooltip"},
  {  path:`${import.meta.env.BASE_URL}elements/toast`, title: "Toast"},
  {  path:`${import.meta.env.BASE_URL}elements/tags`, title: "Tags"},
  {  path:`${import.meta.env.BASE_URL}elements/tabs`, title: "Tabs"},

  { path:`${import.meta.env.BASE_URL}advancedui/accordion`, title: "Accordions" },
  { path:`${import.meta.env.BASE_URL}advancedui/carousel`, title: "Carousel" },
  { path:`${import.meta.env.BASE_URL}advancedui/collapse`, title: "Collapse" },
  { path:`${import.meta.env.BASE_URL}advancedui/modals`, title: "Modal" },
  { path:`${import.meta.env.BASE_URL}advancedui/timeline`, title: "Timeline" },
  { path:`${import.meta.env.BASE_URL}advancedui/sweetalert`, title: "Sweet Alert" },
  { path:`${import.meta.env.BASE_URL}advancedui/ratings`, title: "Rating" },
  { path:`${import.meta.env.BASE_URL}advancedui/counters`, title: "Counters" },
  { path:`${import.meta.env.BASE_URL}advancedui/search`, title: "Search" },
  { path:`${import.meta.env.BASE_URL}advancedui/userlist`, title: "Userlist" },
  { path:`${import.meta.env.BASE_URL}advancedui/blog`, title: "Blog" },
  { path:`${import.meta.env.BASE_URL}advancedui/blogdetails`, title: "Blog-details" },
  { path:`${import.meta.env.BASE_URL}advancedui/editPost`, title: "Edit-post" },
  { path:`${import.meta.env.BASE_URL}advancedui/fileattachments`, title: "File Attachments" },

  { path:`${import.meta.env.BASE_URL}pages/ecommerce/shop`, title: "Shop" },
  { path:`${import.meta.env.BASE_URL}pages/ecommerce/productdetails`, title: "Product Details" },
  { path:`${import.meta.env.BASE_URL}pages/ecommerce/cart`, title: "Cart" },
  { path:`${import.meta.env.BASE_URL}pages/ecommerce/checkout`, title: "Checkout" },
  { path:`${import.meta.env.BASE_URL}pages/ecommerce/wishlist`, title: "Wish-list" },

  { path:`${import.meta.env.BASE_URL}pages/profile`, title:'Profile' },
  { path:`${import.meta.env.BASE_URL}pages/notificationslist`, title:'Notificationslist' },
  { path:`${import.meta.env.BASE_URL}pages/aboutus`, title:'Aboutus' },
  { path:`${import.meta.env.BASE_URL}pages/settings`, title:'Settings' },

  { path:`${import.meta.env.BASE_URL}pages/mail/mail`, title:'Mail' },
  { path:`${import.meta.env.BASE_URL}pages/mail/mailcompose`, title:'MailCompose' },
  { path:`${import.meta.env.BASE_URL}pages/mail/readmail`, title:'Readmail' },
  { path:`${import.meta.env.BASE_URL}pages/mail/mailsettings`, title:'Mailsettings' },
  { path:`${import.meta.env.BASE_URL}pages/mail/chat`, title:'Chat' },

  { path:`${import.meta.env.BASE_URL}pages/invoice`, title:'Invoice' },
  { path:`${import.meta.env.BASE_URL}pages/pricing`, title:'Pricing' },
  { path:`${import.meta.env.BASE_URL}pages/gallery`, title:'Gallery' },
  { path:`${import.meta.env.BASE_URL}pages/todotask`, title:'Todotask' },
  { path:`${import.meta.env.BASE_URL}pages/faqs`, title:'Faqs' },
  { path:`${import.meta.env.BASE_URL}pages/emptypage`, title:'EmptyPage' },
  { path:`${import.meta.env.BASE_URL}pages/switcher/switcher1`,title: 'Switcher-1' } ,

  { path:`${import.meta.env.BASE_URL}utilities/background`, title: "Background"  },
  { path:`${import.meta.env.BASE_URL}utilities/border`, title: "Border"  },
  { path:`${import.meta.env.BASE_URL}utilities/display`, title: "Display"  },
  { path:`${import.meta.env.BASE_URL}utilities/flex`, title: "Flex"  },
  { path:`${import.meta.env.BASE_URL}utilities/height`, title: "Height"  },
  { path:`${import.meta.env.BASE_URL}utilities/margin`, title: "Margin"  },
  { path:`${import.meta.env.BASE_URL}utilities/padding`, title: "Padding"  },
  { path:`${import.meta.env.BASE_URL}utilities/position`, title: "Position"  },
  { path:`${import.meta.env.BASE_URL}utilities/width`, title: "Width"  },
  { path:`${import.meta.env.BASE_URL}utilities/extras`, title: "Extras"  },

  { path:`${import.meta.env.BASE_URL}icons/fontAwesome`, title: "Font Awesome"  },
  { path:`${import.meta.env.BASE_URL}icons/materialDesignicons`, title: "Material Design Icons"  },
  { path:`${import.meta.env.BASE_URL}icons/simpleLineicons`, title: "Simple Line Icons"  },
  { path:`${import.meta.env.BASE_URL}icons/feathericons`, title: "Feather Icons"  },
  { path:`${import.meta.env.BASE_URL}icons/ionicicons`, title: "Ionic Icons"  },
  { path:`${import.meta.env.BASE_URL}icons/flagicons`, title: "Flag Icons"  },
  { path:`${import.meta.env.BASE_URL}icons/pe7icons`, title: "Pe7 Icons"  },
  { path:`${import.meta.env.BASE_URL}icons/themifyicons`, title: "Themify Icons"  },
  { path:`${import.meta.env.BASE_URL}icons/typiconsicons`, title: "Typicons Icons"  },
  { path:`${import.meta.env.BASE_URL}icons/weathericons`, title: "Weather Icons"  },
  { path:`${import.meta.env.BASE_URL}icons/materialicons`, title: "Material Icons"  },
  { path:`${import.meta.env.BASE_URL}icons/bootstrapicons`, title: "Bootstrap Icons"  },

  { path:`${import.meta.env.BASE_URL}charts/chartjs`, title:'ChartJS' },
  { path:`${import.meta.env.BASE_URL}charts/echart`, title:'Echart' },
  { path:`${import.meta.env.BASE_URL}charts/apexcharts`, title:'Apexcharts'},

  { path:`${import.meta.env.BASE_URL}forms/formelements`, title: "Form Elements"},
  { path:`${import.meta.env.BASE_URL}forms/advancedforms`, title: "Advanced Forms"},
  { path:`${import.meta.env.BASE_URL}forms/formlayouts`, title: "Form Layouts"},
  { path:`${import.meta.env.BASE_URL}forms/formvalidation`, title: "Form Validation"},
  { path:`${import.meta.env.BASE_URL}forms/formwizard`, title: "Form Wizard"},
  { path:`${import.meta.env.BASE_URL}forms/formeditor`, title: "Form Editor"},
  { path:`${import.meta.env.BASE_URL}forms/formelementsizes`, title: "Form-element-sizes"},
  { path:`${import.meta.env.BASE_URL}forms/forminputspinners`, title: "Form Input Spinners"},

  { path:`${import.meta.env.BASE_URL}tables/defaulttables`, title:'DefaultTables' },
  { path:`${import.meta.env.BASE_URL}tables/datatables`, title:'DataTables' },

  { path:`${import.meta.env.BASE_URL}widgets`, title:'Widgets'},

  { path:`${import.meta.env.BASE_URL}maps/leafletmaps`, title:'LeafletMaps' },
  { path:`${import.meta.env.BASE_URL}maps/simplemaps`, title:'SimpleMaps' },

{ path:`${import.meta.env.BASE_URL}pages/authentication/sigin`, title: "Sign In"},
{ path:`${import.meta.env.BASE_URL}pages/authentication/sigup`, title: "Sign Up"},
{ path:`${import.meta.env.BASE_URL}pages/authentication/forgotpassword`, title: "Forgot Password"},
{ path:`${import.meta.env.BASE_URL}pages/authentication/resetpassword`, title: "Reset Password"},
{ path:`${import.meta.env.BASE_URL}pages/authentication/lockscreen`, title: "Lockscreen"},
{ path:`${import.meta.env.BASE_URL}pages/authentication/underconstruction`, title: "UnderConstruction"},
{ path:`${import.meta.env.BASE_URL}pages/authentication/404error`, title: "404 Error"},
{ path:`${import.meta.env.BASE_URL}pages/authentication/500error`, title: "500 Error"},
{ path:`${import.meta.env.BASE_URL}pages/authentication/501error`, title: "501 Error"},

];
